import { useEffect } from 'react';

const isTyping = (target) => target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;

/** Ctrl/Cmd+K opens search; "?" (outside text fields) opens the shortcuts help. */
export function useGlobalShortcuts({ onSearch, onHelp }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        onSearch();
      } else if (e.key === '?' && !e.ctrlKey && !e.metaKey && !e.altKey && !isTyping(e.target)) {
        e.preventDefault();
        onHelp();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onSearch, onHelp]);
}
